/* ============================================================================
   WWF-CUSTOM FILE | CL-053 to CL-058 | Added 2026-10-17 | Wild + Well-Fed rebrand
   ----------------------------------------------------------------------------
   Who-can-buy-what rules for the storefront, from the 2026-10-17 usability
   test. Settings and wording come from window.wwfMarket, set in
   snippets/wwf-head.liquid (CL-053 marker). Edit the wording there.

   Sections:
     A. CL-053  Subscription guard (OPEN-069, OPEN-078). Subscriptions are for
                US retail shoppers only. If a non-US shopper or a wholesale
                (B2B) buyer has a subscription in the cart (for example added
                before switching country), it is changed to a one-time
                purchase and a short notice explains why. Bold's "Add to a
                subscription" popup is skipped for them (its Continue button
                is pressed automatically, so the item is added one-time).
                Checkout can still be reached with another address: see the
                Bold / checkout rule note in the change log.
     B. CL-054  Product page price follows Subscribe & Save (OPEN-070). When
                the Bold widget has a plan selected, the product price, the
                Add to Cart button and the sticky cart bar show the
                subscription price; one-time shows the regular price.
     C. CL-055  US-only shipping and subscription wording (OPEN-071). Hidden
                for non-US shoppers: the free shipping bar, the WWF shipping
                banners, announcement messages about free shipping or
                subscriptions, product page free shipping icon lines, the
                "Free shipping on..." icon row, and description lines marked
                "USA only". Wholesale buyers also lose the "USA only"
                description lines (other retail lines are handled by CL-023).
     D. CL-056  International notice (OPEN-068, OPEN-075). Non-US shoppers see
                the same "International Product Availability" note as the
                live Dawn theme at the top of collection and search pages.
                A product link that is not sold in their country explains
                that instead of a bare "page does not exist".
     E. CL-058  Wholesale tidy-up (OPEN-079). Hides the Bundles, Education &
                Courses and Clinic collection tabs for B2B buyers.
   ========================================================================= */
(function () {
  'use strict';

  if (window.wwfMarketLoaded) return;
  window.wwfMarketLoaded = true;

  var M = window.wwfMarket || {};
  var isUS = !!M.isUS;
  var isB2B = !!M.b2b;
  var subsAllowed = isUS && !isB2B;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function hide(el) { if (el && el.style.display !== 'none') el.style.display = 'none'; }

  function formatMoney(cents) {
    var fmt = M.moneyFormat || '${{amount}}';
    var n = Number(cents) || 0;
    function d(num, dec, th, de) {
      var p = (num / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dec ? de : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      return d(n, 2, ',', '.');
    });
  }

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }

  /* Small notice at the bottom of the screen. */
  function toast(message) {
    if (!message) return;
    var old = document.querySelector('.wwf-toast');
    if (old) old.remove();
    var box = document.createElement('div');
    box.className = 'wwf-toast';
    box.setAttribute('role', 'status');
    var text = document.createElement('p');
    text.textContent = message;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wwf-toast__close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    close.addEventListener('click', function () { box.remove(); });
    box.appendChild(text);
    box.appendChild(close);
    document.body.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.remove(); }, 12000);
  }

  /* ---------------------------------------------------------------------
     A. CL-053  Subscription guard
     --------------------------------------------------------------------- */
  var NOTICE_KEY = 'wwfSubGuardNotice';
  var TRY_KEY = 'wwfSubGuardTry';

  function guardMessage() {
    return isB2B ? (M.subNoticeB2B || '') : (M.subNoticeIntl || '');
  }

  var guarding = false;
  function guardCart() {
    if (subsAllowed || guarding) return;
    guarding = true;
    getJSON(ROOT + 'cart.js').then(function (cart) {
      var lines = (cart.items || []).filter(function (i) { return i.selling_plan_allocation; });
      if (!lines.length) { guarding = false; return; }

      // Loop protection: at most 2 attempts a minute.
      var tries = [];
      try { tries = JSON.parse(sessionStorage.getItem(TRY_KEY) || '[]'); } catch (e) {}
      var now = Date.now();
      tries = tries.filter(function (t) { return now - t < 60000; });
      if (tries.length >= 2) { guarding = false; return; }
      tries.push(now);
      try { sessionStorage.setItem(TRY_KEY, JSON.stringify(tries)); } catch (e) {}

      // Change each subscription line to one-time (same quantity).
      var chain = Promise.resolve();
      lines.forEach(function (line) {
        chain = chain.then(function () {
          return getJSON(ROOT + 'cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: null })
          }).catch(function () {});
        });
      });
      return chain.then(function () { return getJSON(ROOT + 'cart.js'); }).then(function (after) {
        // If a line could not be changed, remove it rather than let it through.
        var left = (after.items || []).filter(function (i) { return i.selling_plan_allocation; });
        var rm = Promise.resolve();
        left.forEach(function (line) {
          rm = rm.then(function () {
            return getJSON(ROOT + 'cart/change.js', { method: 'POST', body: JSON.stringify({ id: line.key, quantity: 0 }) }).catch(function () {});
          });
        });
        return rm;
      }).then(function () {
        try { sessionStorage.setItem(NOTICE_KEY, guardMessage()); } catch (e) {}
        window.location.reload();
      });
    }).catch(function () { guarding = false; });
  }

  function showStoredNotice() {
    var msg = '';
    try { msg = sessionStorage.getItem(NOTICE_KEY) || ''; sessionStorage.removeItem(NOTICE_KEY); } catch (e) {}
    if (msg) toast(msg);
  }

  /* Bold's "Add to a subscription" popup: continue as one-time.
     Bold ignores clicks while the popup is still animating in, so wait until
     it has been open for a moment, press Continue once, and press it again
     only if the popup is still open 2.5 seconds later. */
  var boldOpenSince = 0;
  var boldClicks = 0;
  function boldPopupOpen(modal) {
    var box = modal && modal.querySelector('.bold-modal');
    if (!box) return false;
    if (getComputedStyle(box).display === 'none') return false;
    return box.getBoundingClientRect().height > 0;
  }
  function skipBoldPopup() {
    if (subsAllowed) return;
    var modal = document.getElementById('bold-upsell-modal-window');
    if (!boldPopupOpen(modal)) { boldOpenSince = 0; boldClicks = 0; return; }
    var now = Date.now();
    if (!boldOpenSince) { boldOpenSince = now; return; }
    var due = boldClicks === 0 ? 700 : 2500 * boldClicks + 700;
    if (now - boldOpenSince < due || boldClicks >= 3) return;
    var btn = modal.querySelector('.bold-upsell__button--primary');
    if (btn) { boldClicks += 1; btn.click(); }
  }

  /* ---------------------------------------------------------------------
     B. CL-054  Product page price follows Subscribe & Save
     --------------------------------------------------------------------- */
  var productCache = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = getJSON(ROOT + 'products/' + encodeURIComponent(handle) + '.js').catch(function () { return null; });
    }
    return productCache[handle];
  }

  var lastKey = '';
  function pdpSync() {
    if (!subsAllowed || M.template !== 'product') return;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var form = null;
    document.querySelectorAll('form[data-product-form]').forEach(function (f) {
      if (!form && !f.closest('.popup-quick-view__wrapper') && f.querySelector('input[name="selling_plan"]')) form = f;
    });
    if (!form) return;
    var sp = form.querySelector('input[name="selling_plan"]');
    var plan = sp && !sp.disabled ? String(sp.value || '') : '';
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? String(idInput.value) : '';
    var key = plan + '|' + variantId;
    if (key === lastKey) return;
    lastKey = key;
    loadProduct(decodeURIComponent(m[1])).then(function (p) {
      if (!p) return;
      var v = null;
      p.variants.forEach(function (x) { if (String(x.id) === variantId) v = x; });
      if (!v) return;
      var price = v.price;
      if (plan) {
        (v.selling_plan_allocations || []).forEach(function (a) { if (String(a.selling_plan_id) === plan) price = a.price; });
      }
      var scope = form.closest('product-info') || document.querySelector('main') || document;
      var els = Array.prototype.slice.call(scope.querySelectorAll('[data-product-price]'));
      document.querySelectorAll('.cart-bar [data-product-price]').forEach(function (el) { els.push(el); });
      els.forEach(function (el) {
        if (el.closest('.popup-quick-view__wrapper') || el.closest('[data-cart-item]')) return;
        el.textContent = formatMoney(price);
      });
    });
  }

  /* ---------------------------------------------------------------------
     C. CL-055  US-only wording
     --------------------------------------------------------------------- */
  var SHIP = /free\s+shipping/i;
  var SHIP_OR_SUB = /free\s+shipping|subscri/i;
  var USA_ONLY = /\bUSA?\s+only\b/i;

  function hideUSOnly(scope) {
    scope = scope && scope.querySelectorAll ? scope : document;

    // Description lines marked "USA only" about subscriptions or shipping.
    if (!subsAllowed) {
      scope.querySelectorAll('.product__description p, .product__description li, .rte p').forEach(function (el) {
        var t = el.textContent;
        if (USA_ONLY.test(t) && SHIP_OR_SUB.test(t)) hide(el);
      });
    }
    if (isUS) return;

    scope.querySelectorAll('.cart-message, [data-wwf-ship-banners]').forEach(function (el) {
      if (el.matches('[data-wwf-ship-banners]') || SHIP.test(el.textContent)) hide(el);
    });
    // One message at a time: the announcement bar scrolls all messages in a
    // single strip, so hide each message block, never the whole strip.
    scope.querySelectorAll('.announcement__block').forEach(function (el) {
      if (SHIP_OR_SUB.test(el.textContent)) hide(el);
    });
    scope.querySelectorAll('.product__icon__row').forEach(function (el) {
      if (SHIP.test(el.textContent)) hide(el.closest('.product__block') || el);
    });
    scope.querySelectorAll('.icons-row__heading').forEach(function (el) {
      if (SHIP.test(el.textContent)) hide(el.closest('.shopify-section') || el);
    });
  }

  /* ---------------------------------------------------------------------
     D. CL-056  International notice
     --------------------------------------------------------------------- */
  function addNotice() {
    if (isUS || isB2B) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    if ((M.template === 'collection' || M.template === 'search' || M.template === 'list-collections') && M.noticeHtml && !document.querySelector('.wwf-market-notice')) {
      var box = document.createElement('div');
      box.className = 'wwf-market-notice';
      box.innerHTML = '<p>' + M.noticeHtml + '</p>';
      main.insertBefore(box, main.firstChild);
    }

    if (M.template === '404' && /\/products\//.test(window.location.pathname) /* request.path is /404 here */ && M.unavailableHtml) {
      var sub = document.querySelector('#four-oh-four p');
      if (sub) sub.innerHTML = M.unavailableHtml;
    }
  }

  /* ---------------------------------------------------------------------
     E. CL-058  Wholesale: hide retail-only collection tabs
     --------------------------------------------------------------------- */
  var RETAIL_TABS = /\/collections\/(bundles|education-courses|clinic)(?:[/?#]|$)/;
  function hideRetailTabs(scope) {
    if (!isB2B) return;
    scope = scope && scope.querySelectorAll ? scope : document;
    scope.querySelectorAll('.list-collections__item a[href]').forEach(function (a) {
      if (RETAIL_TABS.test(a.getAttribute('href'))) hide(a.closest('.list-collections__item') || a);
    });
  }

  /* ---------------------------------------------------------------------
     Start
     --------------------------------------------------------------------- */
  var queued = false;
  function sweep() {
    queued = false;
    hideUSOnly(document);
    hideRetailTabs(document);
    skipBoldPopup();
  }
  function queueSweep() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(sweep);
  }

  onReady(function () {
    showStoredNotice();
    addNotice();
    sweep();
    guardCart();
    pdpSync();

    new MutationObserver(queueSweep).observe(document.documentElement, { childList: true, subtree: true });

    var guardTimer = null;
    ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:change', 'cart:updated'].forEach(function (name) {
      document.addEventListener(name, function () {
        clearTimeout(guardTimer);
        guardTimer = setTimeout(guardCart, 400);
      });
    });

    if (!subsAllowed) setInterval(skipBoldPopup, 250);

    if (subsAllowed && M.template === 'product') {
      // Bold changes the plan without firing an event, so check twice a second.
      setInterval(pdpSync, 500);
      document.addEventListener('change', function () { setTimeout(function () { lastKey = ''; pdpSync(); }, 120); });
      document.addEventListener('click', function () { setTimeout(pdpSync, 120); setTimeout(function () { lastKey = ''; pdpSync(); }, 600); });
    }
  });
})();
